define(function() {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
        urlRoot: '/delegate/civics-api/api/portal/instruments',
        // url:function(){
        // 	return this.urlRoot;
        // }
        sync: function (method, model, options) {
                if (method == 'update') {
                        model.unset('readyToSubmit', {silent:true});
                }
                return Backbone.sync(method, model, options);
        }
	});
});
